export default __webpack_public_path__ + "static/media/jobin_avatar.715702b2.png";